module.exports = __webpack_public_path__ + "static/media/brego3536.7b576c46.jpg";